import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import {
    ZtFilterChangeEvent,
    ZtFilterEventType,
} from '../zt-filter/zt-filter.model';

interface Option {
    id: string;
}

@Component({
    selector: 'zt-variants-filter',
    templateUrl: 'zt-variants-filter.component.html',
    styleUrls: ['zt-variants-filter.component.scss'],
})
export class ZtVariantsFilterComponent implements OnInit, OnChanges {
    @Input() options: string[] | undefined = [];

    @Output() filterChange = new EventEmitter<ZtFilterChangeEvent>();

    selectedOptions: string[] = [];
    listOfOptions: Option[] = [];

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        const changedOptions = changes['options'];
        if (changedOptions && Array.isArray(changedOptions.currentValue)) {
            this.listOfOptions = changedOptions.currentValue.map((value) => {
                return { id: value };
            });
        }
    }

    ngOnInit(): void {}

    onChange(values: Option[]) {
        if (values.length === 0) {
            this.filterChange.emit({
                type: ZtFilterEventType.ALL_MATCH,
            } as ZtFilterChangeEvent);

            return;
        }

        this.filterChange.emit({
            type: ZtFilterEventType.MATCH,
            data: values.map((value) => value.id),
        } as ZtFilterChangeEvent);
    }
}
